import React, { useState, useEffect } from 'react';
import StepCard from './components/StepCard';
import ToggleSwitch from './components/ToggleSwitch';
import { Button } from '../../../components/ui/button';
import { Select, SelectItem } from '../../../components/ui/select';
import AppShell from '../../../components/AppShell';
import { Badge } from '../../../components/ui/badge';
import { useNavigate } from 'react-router-dom';
import {
  handleInstagramConnect,
  handleWhatsAppConnect,
} from './utils/metaConnect';


const API = process.env.REACT_APP_API_BASE;

export default function ReplyBotOnboarding() {
  const navigate = useNavigate();

  const [instagramConnected, setInstagramConnected] = useState(false);
  const [whatsappConnected, setWhatsappConnected] = useState(false);
  const [tone, setTone] = useState('friendly');
  const [language, setLanguage] = useState('en');
  const [ctaStyle, setCtaStyle] = useState('direct');
  const [autoReplyInstagram, setAutoReplyInstagram] = useState(true);
  const [autoReplyWhatsApp, setAutoReplyWhatsApp] = useState(true);
  const [fbSignupReady, setFbSignupReady] = useState(false);

  const handleSaveConfig = () => {
    // Save to backend (optional API call)
    console.log({
      tone,
      language,
      ctaStyle,
      autoReplyInstagram,
      autoReplyWhatsApp,
    });
    navigate('/replybot/inbox');
  };

  useEffect(() => {
    const fetchStatus = async () => {
      const res = await fetch(`${API}/api/replybot/status`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      const data = await res.json();
      setInstagramConnected(data.instagramConnected);
      setWhatsappConnected(data.whatsappConnected);
    };
  
    fetchStatus();
  }, []);
  

  const launchOAuthConnect = (type) => {
    const appId = process.env.REACT_APP_META_APP_ID;
    const redirectUri = `https://app.ennoverse.ai/apps/replybot/connect/callback`;
    let scope = '';
  
    if (type === 'instagram') {
      scope = 'instagram_basic,instagram_manage_messages,pages_show_list,pages_read_engagement';
    } else if (type === 'whatsapp') {
      scope = 'whatsapp_business_management,business_management';
    }
  
    const oauthUrl = `https://www.facebook.com/dialog/oauth?client_id=${appId}&redirect_uri=${encodeURIComponent(redirectUri)}&state=${type}&scope=${scope}`;
    window.open(oauthUrl, '_blank');
  };
  
  
  
  

  return (
    <AppShell>
        <div className="col-span-12 space-y-6">
    <div className="max-w-3xl mx-auto py-10 px-4 space-y-6">
      <StepCard title="Welcome to ReplyBot">
        <p className="text-muted-foreground">
          Connect your Instagram and WhatsApp accounts to let ReplyBot handle
          your DMs with AI-powered responses.
        </p>
      </StepCard>

      <StepCard title="Connect Instagram">
  {instagramConnected ? (
    <Badge variant="success">Instagram Connected ✅</Badge>
  ) : (
    <Button onClick={() => launchOAuthConnect('instagram')}>
      🔗 Connect Instagram
    </Button>
  )}
</StepCard>

<StepCard title="Connect WhatsApp">
  {whatsappConnected ? (
    <Badge variant="success">WhatsApp Connected ✅</Badge>
  ) : (
    <Button onClick={() => window.open('/apps/replybot/whatsapp-connect', '_blank')}>
    📞 Connect WhatsApp
  </Button>
  )}
</StepCard>


      <StepCard title="Set Your Reply Preferences">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <Select label="Tone" value={tone} onValueChange={setTone}>
            <SelectItem value="friendly">Friendly</SelectItem>
            <SelectItem value="professional">Professional</SelectItem>
            <SelectItem value="fun">Fun</SelectItem>
          </Select>
          <Select label="Language" value={language} onValueChange={setLanguage}>
            <SelectItem value="en">English</SelectItem>
            <SelectItem value="ar">Arabic</SelectItem>
            <SelectItem value="hi">Hindi</SelectItem>
          </Select>
          <Select
            label="CTA Style"
            value={ctaStyle}
            onValueChange={setCtaStyle}
          >
            <SelectItem value="direct">Direct</SelectItem>
            <SelectItem value="soft">Soft</SelectItem>
            <SelectItem value="promo">Promotional</SelectItem>
          </Select>
        </div>
      </StepCard>

      <StepCard title="Enable Auto-Reply">
        <div className="space-y-2">
          <ToggleSwitch
            label="Enable AI Auto-Reply for Instagram DMs"
            checked={autoReplyInstagram}
            onCheckedChange={setAutoReplyInstagram}
          />
          <ToggleSwitch
            label="Enable AI Auto-Reply for WhatsApp"
            checked={autoReplyWhatsApp}
            onCheckedChange={setAutoReplyWhatsApp}
          />
        </div>
      </StepCard>

      <Button className="w-full mt-6" onClick={handleSaveConfig}>
        Save & Continue to Inbox
      </Button>
      
    </div>
    </div>
    </AppShell>
  );
}
